import axios from "axios";
import { TLangType } from "../types/LangType";
import { ISemRushKeywords } from "../types/semrush";

export const SemRushTransport = {
    getKeywords: async (
        keyword: string,
        numberOfKeywords: number,
        lang: TLangType
    ): Promise<Array<ISemRushKeywords> | string> => {
        const { data } = await axios.get(
            `/semRush/getKeywords?keyword=${keyword}&numberOfKeywords=${numberOfKeywords}&lang=${lang}`,
            {}
        );

        return data;
    },
};
